export const userViewEditPayment = () => ({
  type: 'View Edit Payment Info page',
});
